<template>
  <div>
    <div class="third-rea slideshowFrom">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="search()">查询</el-button>
          <el-button class="btn-two" type="default" @click="resetForm('formInline')">重置</el-button>
          <span class="btn-shu"></span>
          <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
        </div>
      </div>
      <div class="third-search">
        <el-form :inline="true" :model="formInline" label-width="76px" ref="formInline">
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="排序" prop="sort">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="formInline.sort"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="标题" prop="title">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="formInline.title"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="状态" prop="status">
                <el-select class="item-input" v-model="formInline.status" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="(items, index) in pointList"
                    :key="index"
                    :value="items.value"
                    :label="items.label"
                  ></el-option>
                </el-select>
                <!-- <key-value-select
                  :className="'item-input'"
                  :isNeedAll="true"
                  v-model="formInline.status"
                  placeholder="请选择"
                  dictUrl="api/blade-workbench/dict/dictionary?code=status"
                ></key-value-select>-->
                <!-- <el-select class="item-input" v-model="formInline.status" placeholder="请选择">
                  <el-option label="全部" value="def"></el-option>
                  <el-option
                    v-for="(item, index) in yearSelectList"
                    :key="index"
                    :value="item.ID"
                    :label="item.year"
                  ></el-option>
                </el-select>-->
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="更新时间" prop="updateTimeEnd">
                <el-date-picker
                  style="margin-top:4px; width:216px;padding-left:0;padding-right:0;"
                  class="list-input Isdaterange"
                  v-model="formInline.updateTimeEnd"
                  type="daterange"
                  unlink-panels
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd"
                  align="right"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="checkDate"
                ></el-date-picker>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one slideshow">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button class="do-btn-two" type="default" icon="el-icon-plus" @click="addItem()">新增</el-button>
          <el-button
            class="do-btn-two"
            type="default"
            icon="el-icon-video-play"
            @click="deleteItem(null,1)"
          >启用</el-button>
          <el-button
            class="do-btn-two"
            type="default"
            icon="el-icon-video-pause"
            @click="deleteItem(null,0)"
          >停用</el-button>
          <el-button
            class="do-btn-two"
            type="default"
            icon="el-icon-delete"
            @click="deleteItem(null,null)"
          >删除</el-button>
        </div>
        <div class="do-btn-right">
          <div class="do-btn-check">
            <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
            <span class="btn-check-span">显示高级功能</span>
          </div>
          <div class="do-btn-hign-list" v-if="checked">
            <!-- 展示字段 -->
            <sort-data
              :tableRow="tableRow"
              @showList="getTableList"
              sessionOriginalName="yuanxiSortOrignalData"
              sessionResultName="yuanxiSortData"
            ></sort-data>
            <!-- 数据顺序 -->
            <display-field
              :selectList="tableRow"
              sessionOriginalName="yuanxiDisplayFiedOrignal"
              @setDataOrder="getDataOrder"
              sessionResultName="yuanxiDisplayFied"
            ></display-field>
          </div>
        </div>
      </div>
      <el-table
        class="third-tableThree"
        :data="tableData"
        border
        stripe
        ref="YXtableData"
        @select="handleSelectChange"
        @select-all="handleSelectAll"
        :row-key="getRowKey"
        v-loading="loading"
      >
        <el-table-column type="selection" :reserve-selection="true" width="32px"></el-table-column>
        <template v-for="(item, index) in tableDataShow">
          <!-- <template v-for="(item, index) in $store.state.power.selectConfig.eduCollegeInfo"> -->
          <el-table-column
            v-if="item.needKeyValue"
            min-width="100px"
            :prop="item.key"
            :label="item.column"
            :key="index"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <key-value-span :value="scope.row[item.key]" :dictUrl="item.actionUrl"></key-value-span>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :min-width="item.key == 'imgUrl' ? '166px' : '100px'"
            :width="item.key == 'imgUrl' ? '166px' : ''"
            :prop="item.key"
            :label="item.column"
            :key="index"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-if="item.key == 'imgUrl'">
                <img
                  :src="scope.row['imgUrl']"
                  :alt="scope.row['id']"
                  style="width:144px;height:76px;margin-top:8px;margin-left:3px;cursor: pointer;"
                  @click="openIMG(scope.row['imgUrl'])"
                />
              </span>
              <span v-else-if="item.key == 'status'">{{scope.row['status'] == 1 ? '启用' : '停用'}}</span>
              <span v-else-if="item.key == 'detailUrl'">
                <el-button
                  type="text"
                  size="small"
                  @click="lookDetail(scope.row[item.key])"
                >{{scope.row[item.key]}}</el-button>
              </span>
              <span v-else>{{scope.row[item.key]}}</span>
            </template>
          </el-table-column>
        </template>
        <!-- <el-table-column prop="collegeId" label="院系代码"></el-table-column>
        <el-table-column prop="collegeName" label="院系名称"></el-table-column>
        <el-table-column prop="campusName" label="所属校区"></el-table-column>
        <el-table-column prop="director" label="负责人"></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
        <el-table-column prop="leader" label="xxx">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="lookDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="更新时间"></el-table-column>
        <el-table-column prop="dataFrom" label="数据来源"></el-table-column>-->
        <!-- <el-table-column
          prop="address"
          label="附件">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small">
              身份证扫描件.pdf
            </el-button>
          </template>
        </el-table-column>-->
        <el-table-column min-width="131px" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="selectYX(scope.row)" type="text" size="small">详情</el-button>
            <span style="height:100%">
              <span
                style="margin-left: 8px;margin-right: 8px;width: 1px;height: 12px;display: inline-block;background-color: #D4D4D7;vertical-align: middle;"
              ></span>
            </span>
            <el-button
              @click="deleteItem(scope.row,scope.row['status'] == 1 ? 0 : 1)"
              type="text"
              size="small"
            >{{scope.row['status'] == 1 ? '停用' : '启用'}}</el-button>
            <span style="height:100%">
              <span
                style="margin-left: 8px;margin-right: 8px;width: 1px;height: 12px;display: inline-block;background-color: #D4D4D7;vertical-align: middle;"
              ></span>
            </span>
            <el-button @click="deleteItem(scope.row,null)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="third-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tot"
        ></el-pagination>
      </div>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :isError="isError"
      btnAgree="确认"
      :noticeContent="noitceContent"
    ></notice-modal>
    <hign-modal
      :hignModalVisible="hignModal"
      @searchModal="toHignSearch"
      @cancelModal="closeModal"
      :hignOneList="hignList"
    ></hign-modal>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Sortable from "sortablejs";
import { getStore } from "@/utils/store";
import { select, delect, openClose } from "@/api/slidenshow/slidenshow";
// import keyValueSelect from "@/components/key-value/key-value-select";
import keyValueSpan from "@/components/key-value/key-value-span";

export default {
  name: "thirdThree",
  components: {
    // keyValueSelect,
    keyValueSpan
  },
  data() {
    return {
      loading: false,
      isIndeterminate: true,
      outputModal: false, // 导出弹窗
      dialogImageUrl: "",//看大图
      dialogVisible: false,//看大图弹窗
      isJS: true, //是否有检索条件
      rulesOutPut: {
        jbDesc: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      ruleFormOutPut: {
        checkAll: false, // 全选
        jbDesc: "学生基础数据201908021223",
        fileList: [], // 文件列表
        gzRadio: "", // 重复规则
        fieldGroup: [] // 检查字段
      },
      detailModal: false, // 详情弹窗
      isError: true, // 是否是错误提示
      noticeSpec: "", // 标红提示
      noticeTitle: "确认操作", // 提示
      noitceContent: "是否确认删除？", // 提示信息
      noticeModal: false, // 提示弹窗
      isCz: "", //确认操作类型
      delectID: "", //删除一条数据的ID
      fieldArr: [
        {
          id: 1,
          label: "学号"
        },
        {
          id: 2,
          label: "姓名"
        },
        {
          id: 3,
          label: "专业"
        },
        {
          id: 4,
          label: "民族"
        },
        {
          id: 5,
          label: "班级"
        },
        {
          id: 6,
          label: "院系"
        },
        {
          id: 7,
          label: "本学期表现"
        },
        {
          id: 8,
          label: "学校"
        },
        {
          id: 9,
          label: "超过五个字的内容"
        },
        {
          id: 10,
          label: "这也是超过五个字的内容"
        }
      ],
      rulesImport: {
        jbDesc: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      ruleFormImport: {
        jbDesc: "",
        fileList: [], // 文件列表
        gzRadio: "", // 重复规则
        fieldGroup: [] // 检查字段
      },
      importModal: false, // 导入弹窗
      fieldsTableData: [
        {
          fields: "用户ID",
          isChecked: false
        },
        {
          fields: "姓名",
          isChecked: false
        },
        {
          fields: "学号",
          isChecked: false
        },
        {
          fields: "性别",
          isChecked: false
        },
        {
          fields: "民族",
          isChecked: false
        },
        {
          fields: "院系",
          isChecked: true
        },
        {
          fields: "专业",
          isChecked: false
        },
        {
          fields: "班级",
          isChecked: false
        },
        {
          fields: "部门",
          isChecked: false
        }
      ], // 字段显示数据
      fieldsModal: false, // 字段显示弹窗
      pageSize: 10,
      currentPage4: 1,
      tot: 0,
      tableData: [],
      hignModal: false, // 高级搜索
      pointList: [
        {
          value: 1,
          label: "启用"
        },
        {
          value: 0,
          label: "停用"
        }
      ], //API状态下拉框
      yearSelectList: [], // 学年学期下拉列表
      formInline: {
        sort: "", // 序号
        title: "", // 标题
        // SSxiaoquID: "",
        status: "", // 状态
        updateTimeEnd: null, // 更新时间
        stratTime: "",
        endTime: ""
      },
      checked: true,
      checkClassList: [],
      checkID: "", //表格选中的ID
      hignSearchRes: "", // 高级检索条件
      // 字段展示和顺序需要的参数
      orderConfig: "",
      tableDataShow: [],
      tableRow: [
        {
          column: "图片",
          key: "imgUrl",
          needKeyValue: false,
          caseKey: "img_url"
        },
        {
          column: "标题",
          key: "title",
          needKeyValue: false,
          caseKey: "title"
        },
        {
          column: "网址",
          key: "detailUrl",
          needKeyValue: false,
          caseKey: "detail_url"
        },
        {
          column: "排序",
          key: "sort",
          needKeyValue: false,
          caseKey: "sort"
        },
        {
          column: "状态",
          key: "status",
          needKeyValue: false,
          caseKey: "status",
          isCustomList: [
              {
              label: '启用',
              value: '1'
              },
              {
              label: '停用',
              value: '0'
              }
          ]
        },
        {
          column: "更新时间",
          key: "updateTime",
          needKeyValue: false,
          caseKey: "update_time"
        }
      ],
      hignList: [
        {
          column: "标题",
          key: "title",
          needKeyValue: false,
          caseKey: "title"
        },
        {
          column: "网址",
          key: "detailUrl",
          needKeyValue: false,
          caseKey: "detail_url"
        },
        {
          column: "排序",
          key: "sort",
          needKeyValue: false,
          caseKey: "sort"
        },
        {
          column: "状态",
          key: "status",
          needKeyValue: false,
          caseKey: "status",
          isCustomList: [
              {
              label: '启用',
              value: '1'
              },
              {
              label: '停用',
              value: '0'
              }
          ]
        },
        {
          column: "更新时间",
          key: "updateTime",
          needKeyValue: false,
          caseKey: "update_time"
        }
      ]
    };
  },
  computed: {
    // ...mapState({
    //   //   tableRow: state => state.power.selectConfig.eduCollegeInfo
    // })
  },
  created() {
    const dispField = this.getSessonValue("yuanxiDisplayFied");
    const tableRow = this.getSessonValue("yuanxiSortData");
    console.log(this.tableData.length);
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
      console.log("字段", this.tableDataShow);
    } else {
      this.tableDataShow = this.tableRow;
      console.log("字段", this.tableDataShow);
    }
    console.log("字段", this.tableDataShow);
    this.selectList();
  },
  methods: {
    //点击图片看大图
    openIMG(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    //关闭预览弹窗
    closePreview() {
      this.dialogVisible = false;
    },
    //选择时间后处理时间
    checkDate() {
      console.log("选择的时间", this.formInline.updateTimeEnd);
      this.formInline.stratTime = this.formInline.updateTimeEnd[0];
      this.formInline.endTime = this.formInline.updateTimeEnd[1];
    },
    //导入成功后刷新列表
    daoruSuccess() {
      this.resetForm("formInline");
      // this.selectList()
    },
    // 高级检索
    toHignSearch(res) {
      console.log(res);
      this.hignSearchRes = res;
      this.currentPage4 = 1;
      this.hignModal = false;
      this.selectList();
    },
    //获取label
    getLabel(val) {
      this.formInline.SSxiaoquID = val;
      console.log("这是SSxiaoquID", this.formInline.SSxiaoquID);
    },
    // 新增
    addItem() {
      console.log("新增");
      this.$emit("add", null);
    },
    // 编辑
    editItem(id) {
      console.log("编辑");
      this.$emit("add", id);
    },
    //获取列表
    selectList() {
      try {
        console.log("看一看orderConfig", this.orderConfig);
        let dataSortStr = this.orderConfig;
        if (Array.isArray(this.orderConfig)) {
          console.log(
            "看一看orderConfig的type",
            Array.isArray(this.orderConfig)
          );
          dataSortStr = this.orderConfig.join(",");
        }
        const params = {
          imgInfo: {
            //查询条件
            sort: this.formInline.sort, //序号
            title: this.formInline.title, //标题
            status: this.formInline.status, //状态 1启用 0停用
            updateTimeStart: this.formInline.stratTime, //更新时间 开始
            updateTimeEnd: this.formInline.endTime //更新时间 结束
          },
          pageIndex: this.currentPage4,
          pageSize: this.pageSize,
          dataSortStr: dataSortStr, //数据排序
          advancedSearch: this.hignSearchRes // 高级检索
        };
        this.loading = true 
        select(params).then(res => {
          this.loading = false
          const data = res.data;
          console.log("这是轮播图管理接口", data);
          if (data.status === 1000) {
            this.tableData = data.result.records;
            this.tot = data.result.total;
          } else {
            this.tableData = [];
            this.tot = 0;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询详情
    selectYX(row) {
      console.log("这是轮播图详情", row);
      this.editItem(row);
    },
    //启用或开启
    openORclose(row, status) {
      console.log("启用或停用", row);
      try {
        const params = {
          status: status, //轮播图状态 1启用 0停用
          ids: row //轮播图id数组 以英文逗号分隔
        };
        openClose(params).then(res => {
          const data = res.data;
          console.log("这是轮播图启用或停用接口", data);
          if (data.status === 1000) {
            this.delectID = "";
            this.selectList();
            this.$message.success(this.isCz + "成功");
            this.$refs.YXtableData.clearSelection();
            this.checkClassList = [];
            this.checkID = "";
          } else {
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //批量启用或停用
    AllopenORclose(status) {
      try {
        const IScollegeInfoId = this.checkClassList.join(",");
        console.log("这是轮播图启用停用多条数据", IScollegeInfoId);
        const params = {
          status: status, //轮播图状态 1启用 0停用
          ids: IScollegeInfoId // collegeInfoId ,多个id以‘，’隔开
        };
        openClose(params).then(res => {
          const data = res.data;
          console.log("这是院系管理删除接口", data);
          if (data.status === 1000) {
            this.selectList();
            this.$message.success(this.isCz + "成功");
            this.$refs.YXtableData.clearSelection();
            this.checkClassList = [];
            this.checkID = "";
          } else {
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //删除
    delect(row) {
      console.log("删除", row);
      try {
        const params = {
          ids: row // collegeInfoId ,多个id以‘，’隔开
        };
        delect(params).then(res => {
          const data = res.data;
          console.log("这是轮播图删除接口", data);
          if (data.status === 1000) {
            this.delectID = "";
            this.selectList();
            this.$message.success("删除成功");
            this.$refs.YXtableData.clearSelection();
            this.checkClassList = [];
            this.checkID = "";
          } else {
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //删除多条
    Alldelect() {
      try {
        const IScollegeInfoId = this.checkClassList.join(",");
        console.log("这是轮播图删除多条数据", IScollegeInfoId);
        const params = {
          ids: IScollegeInfoId // collegeInfoId ,多个id以‘，’隔开
        };
        delect(params).then(res => {
          const data = res.data;
          console.log("这是轮播图删除接口", data);
          if (data.status === 1000) {
            this.selectList();
            this.$message.success("删除成功");
            this.$refs.YXtableData.clearSelection();
            this.checkClassList = [];
            this.checkID = "";
          } else {
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //保存选中状态
    getRowKey(row) {
      return row.id;
    },
    //表格多选框选中
    handleSelectChange(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].id);
      }
      this.checkID = this.checkClassList.join(",");
      console.log("这是我选择的选项", this.checkClassList);
    },
    //表格全选中
    handleSelectAll(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].id);
      }
      this.checkID = this.checkClassList.join(",");
      console.log("这是我的选项", this.checkClassList);
    },
    // 全选变化
    handleCheckAllChange(val) {
      console.log(val);
      this.ruleFormOutPut.fieldGroup = val ? this.fieldArr : [];
      console.log(this.ruleFormOutPut.fieldGroup);
      this.isIndeterminate = false;
    },
    // 多个选中变化
    handleCheckedCitiesChange(value) {
      console.log(value);
      let checkedCount = value.length;
      if (checkedCount === this.fieldArr.length) {
        this.ruleFormOutPut.checkAll = true;
      }
      if (checkedCount > 0 && checkedCount < this.fieldArr.length) {
        this.isIndeterminate = true;
      }
    },
    // 确认详情
    agreeDetail() {
      this.detailModal = false;
    },
    // 查看详情
    lookDetail(row) {
      console.log(row);
      window.open(row);
    },
    // 确认弹窗
    agreeNotice() {
      console.log("确定弹窗", this.delectID);
      if (this.delectID !== "") {
        if (this.isCz == "删除") {
          this.delect(this.delectID);
        } else if (this.isCz == "启用") {
          this.openORclose(this.delectID, 1);
        } else if (this.isCz == "停用") {
          this.openORclose(this.delectID, 0);
        }
      } else {
        // this.Alldelect();
        if (this.isCz == "删除") {
          this.Alldelect();
        } else if (this.isCz == "启用") {
          this.AllopenORclose(1);
        } else if (this.isCz == "停用") {
          this.AllopenORclose(0);
        }
      }
      this.noticeModal = false;
    },
    // 关闭弹窗
    closeNotice() {
      // this.$refs.YXtableData.clearSelection();
      // this.checkClassList = [];
      this.delectID = "";
      this.noticeModal = false;
    },
    // 删除弹窗打开
    deleteItem(row, status) {
      console.log(row);
      if (row == null) {
        if (this.checkClassList.length == 0) {
          this.$message.warning("请选择数据");
        } else {
          if (status == null) {
            this.noitceContent = "是否确认删除？";
            this.isCz = "删除";
          } else if (status == 1) {
            this.noitceContent = "是否确认启用？";
            this.isCz = "启用";
          } else {
            this.noitceContent = "是否确认停用？";
            this.isCz = "停用";
          }
          this.noticeModal = true;
        }
      } else {
        this.delectID = row.id;
        if (status == null) {
          this.noitceContent = "是否确认删除？";
          this.isCz = "删除";
        } else if (status == 1) {
          this.noitceContent = "是否确认启用？";
          this.isCz = "启用";
        } else {
          this.noitceContent = "是否确认停用？";
          this.isCz = "停用";
        }
        this.noticeModal = true;
      }
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
    },
    //条数变化
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage4 = 1;
      this.pageSize = val;
      this.selectList();
      this.pageChanageSelect();
    },
    //页码变化
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage4 = val;
      this.selectList();
      this.pageChanageSelect();
    },
    //页面变化时
    pageChanageSelect() {
      console.log("切换", this.checkClassList);
    },
    //查询
    search() {
      console.log(this.formInline);
      this.hignSearchRes = "";
      this.currentPage4 = 1;
      this.selectList();
    },
    getTableList(value) {
      this.tableDataShow = value;
    },
    getDataOrder(value) {
      this.orderConfig = value;
      console.log("改变了数据顺序", this.orderConfig);
      this.selectList();
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session"
      });
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formInline.stratTime = "";
      this.formInline.endTime = "";
      //   this.formInline.dataFrom = "";
      //   this.formInline.status = "";
      console.log("重置", this.formInline);
      this.search();
    }
  }
};
</script>

<style lang="scss">
.third {
  .slideshow {
    .third-tableThree {
      .el-table__body-wrapper {
        height: calc(100vh - 196px) !important;
      }
    }
    .fileDisabled {
      .el-upload--picture-card {
        display: none;
      }
    }
  }
  .slideshowFrom {
    .el-date-editor .el-range__icon {
      display: none !important;
    }
    .el-date-editor .el-range-separator {
      padding: 0 8px;
    }
    .el-range-editor--small .el-range-input {
      width: 100px;
    }
  }
}
</style>
